import React, { useEffect, useState } from 'react';
import { Input, Label, Button } from 'reactstrap';

const AfasOpmerkingMemoPanel = ({ memo = {}, onSave }) => {
    const [value, setValue] = useState(memo.memoSalarisadministratie ?? '');

    useEffect(() => {
        setValue(memo.memoSalarisadministratie ?? '');
    }, [memo.memoSalarisadministratie]);

    return (
        <div className="afas-sub-tab-panel afas-memo-panel">
            <div className="afas-form-field afas-form-field--stacked">
                <Label htmlFor="afas-memo-salaris" className="afas-form-field__label">
                    Memo t.b.v. salarisadministratie
                </Label>
                <Input
                    id="afas-memo-salaris"
                    type="textarea"
                    rows={8}
                    className="form-control afas-memo-panel__textarea"
                    placeholder="Text"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                />
                <div className='d-flex justify-content-center'>
                    <Button
                        type="button"
                        color="primary"
                        size="sm"
                        className="mt-2 btn btn-primary"
                        onClick={() => onSave?.(value)}
                    >
                        Opslaan
                    </Button>
                </div>

            </div>
        </div>
    );
};

export default AfasOpmerkingMemoPanel;
